import LocationBase from '../../models/LocationObjects/LocationBase'

type LocationFilterableFields = Pick<LocationBase, 'id' | 'type' | 'name'>

export const locationFilterPropMap: Record<
  string,
  keyof LocationFilterableFields
> = {
  ID: 'id',
  TYPE: 'type',
  NAME: 'name',
}
